import { Attachment } from '@sentry/types';

import { AJSResponse } from '@qality/common-model/src/AP/AJS';

import API from './API';

export default {
  async postAttachments(
    issueIdOrKey: string | number,
    files: Blob[]
  ): Promise<Attachment[]> {
    const promises = [];

    files.forEach((file) => {
      const form = new FormData();
      form.append('file', file);
      promises.push(this.postAttachment(issueIdOrKey, form));
    });

    return Promise.all(promises).then((responses) => {
      return responses.map<Attachment>((response) => {
        const attachments = JSON.parse(response.body);
        return attachments[0];
      });
    });
  },

  postAttachment(issueIdOrKey: string, file: Blob): Promise<AJSResponse> {
    return API.request({
      url: `/rest/api/2/issue/${issueIdOrKey}/attachments`,
      type: 'POST',
      headers: {
        'X-Atlassian-Token': 'no-check',
      },
      contentType: false,
      processData: false,
      data: file,
    });
  },

  fetchAttachment(attachmentId: number): Promise<AJSResponse> {
    return API.noRetry({
      type: 'GET',
      url: `/rest/api/2/attachment/${attachmentId}`,
    });
  },

  deleteAttachment(id: number): Promise<AJSResponse> {
    return API.request({
      type: 'DELETE',
      url: `/rest/api/2/attachment/${id}`,
    });
  },
};
